import * as React from "react";
import {Component} from "react";

import {connect} from "react-redux";
import {IRootState} from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import AnalyticsDateControls from "../../../AnalyticsDateControls";
import H from "history";
import ApiService from "../../../ApiService";
import WorkloadStatusesOverTimeCard from "../../../WorkloadStatusesOverTimeCard";
import {WorkloadAnalytics} from "../../../../models/WorkloadAnalytics";
import WorkloadPerformanceList from "../../../WorkloadPerformanceList";
import WorkUnitPerformanceList from "../../../WorkUnitPerformanceList";
import WorkloadStatsOverTimeCard from "../../../WorkloadStatsOverTimeCard";
import WorkUnitStatsCharts from "../../../WorkUnitStatsCharts";
import LoadingCard from "../../../LoadingCard";


interface WorkloadAnalyticsPageProps {
    startDate: string;
    endDate: string;
    history: H.History;
    apiService: ApiService;
}

interface WorkloadAnalyticsPageState {
    workloadAnalytics?:  WorkloadAnalytics;
    selectedWorkloadName?: string;
    isLoading: boolean;
}


class WorkloadAnalyticsPage extends Component<WorkloadAnalyticsPageProps & DispatchProps,WorkloadAnalyticsPageState> {

    constructor(props: WorkloadAnalyticsPageProps & DispatchProps) {
        super(props);

        this.state = {
            workloadAnalytics: undefined,
            selectedWorkloadName: undefined,
            isLoading: true
        };
    }

    async componentDidMount(): Promise<void> {
        if(this.props.startDate && this.props.endDate)
        {
            const workloadAnalytics = await this.props.apiService.getWorkloadAnalytics(this.props.startDate,this.props.endDate);
            this.setState({
                workloadAnalytics,
                isLoading: false
            });
        }
    }

    async componentDidUpdate(prevProps: Readonly<WorkloadAnalyticsPageProps & DispatchProps>, prevState: any): Promise<void>
    {
        if (this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate)
        {
            this.setState({
                isLoading: true,
                workloadAnalytics: undefined
            });

            const workloadAnalytics = await this.props.apiService.getWorkloadAnalytics(this.props.startDate, this.props.endDate);

            this.setState({
                workloadAnalytics,
                isLoading: false
            });
        }
    }

    
    private onWorkloadClicked = (workloadName: string) =>
    {
        this.setState({
            selectedWorkloadName: workloadName
        });
    }
    
    public render(): JSX.Element {
        
        
        return (
            <React.Fragment>
                <AnalyticsDateControls history={this.props.history}>
                    <span className={"text-tiny p-top-05rem"}>Previous day added daily (7am UTC)</span>
                </AnalyticsDateControls>

                {this.state.isLoading ? <LoadingCard text={"Fetching Data"} /> : null}
                
                {this.state.workloadAnalytics ? <WorkloadStatusesOverTimeCard workloadStats={this.state.workloadAnalytics.workloadStats}/> : null}
                {this.state.selectedWorkloadName && this.state.workloadAnalytics ? <WorkloadStatsOverTimeCard workloadStats={this.state.workloadAnalytics.workloadStats} selectedWorkloadName={this.state.selectedWorkloadName} /> : null}
                {this.state.workloadAnalytics ? <WorkloadPerformanceList workloadStats={this.state.workloadAnalytics.workloadStats} onClick={this.onWorkloadClicked}/> : null}
                {this.state.workloadAnalytics ? <WorkUnitStatsCharts workUnitStats={this.state.workloadAnalytics?.workUnitStats}/> : null }
                {this.state.workloadAnalytics ? <WorkUnitPerformanceList workUnitStats={this.state.workloadAnalytics?.workUnitStats}/> : null}
            </React.Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {match: any,history: H.History}): WorkloadAnalyticsPageProps => {

        const {startDate,endDate} = AnalyticsDateControls.fromQueryStringOrDefault(ownProps.history.location.search);

        return {
            startDate,
            endDate,
            history: ownProps.history,
            apiService: state.auth.apiService
        };

    }
)(WorkloadAnalyticsPage)